import React, { useState, useEffect } from "react";
import {
  Button,
  TextField,
  FormControl,
  MenuItem,
  Paper,
  Menu,
} from "@mui/material";
import { IconButton, } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

import api from "../../../api";
import Swal from "sweetalert2";
import UniqueLoader from "../loader";
import { DataGrid } from "@mui/x-data-grid";
import Adminsidebar from "../adminsidebar";
import Adminheader from "../adminheader";

function MspGallary() {
  const [loading, setloading] = useState(false);
  const [Msp_Gallary, setMsp_Gallary] = useState({
    msp_gallary: [],
  });

  const [rowCount, setRowCount] = useState(0);
  const [paginationModel, setPaginationModel] = useState({
    page: 0, // DataGrid pages start from 0
    pageSize: 10,
  });

  const [All_Msp_Gallary, setAll_Msp_Gallary] = useState([]);
  const getall_msp_gallary = async (
    pageNumber = paginationModel.page,
    limitNumber = paginationModel.pageSize
  ) => {
    try {
      setloading(true);
      const params = new URLSearchParams();

      // Pagination
      params.append("page", pageNumber + 1); // backend is 1-indexed
      params.append("limit", limitNumber);

      const resp = await api.get(
        `api/msp/Getmsp-gallary?${params.toString()}`
      );

      setAll_Msp_Gallary(resp.data.mspGallary);
      setRowCount(resp.data.total);
    } catch (error) {
      console.log(error);
    } finally {
      setloading(false);
    }
  };

  useEffect(() => {
    getall_msp_gallary();
  }, [paginationModel]);

  const [menuAnchor, setMenuAnchor] = useState(null);
  const [menuRowId, setMenuRowId] = useState(null);

  const handleOpenMenu = (event, rowId) => {
    setMenuAnchor(event.currentTarget);
    setMenuRowId(rowId);
  };

  const handleCloseMenu = () => {
    setMenuAnchor(null);
    setMenuRowId(null);
  };

  const [lookup_id, setlookup_id] = useState(null);
  const onEdit = (row) => {
    setlookup_id(row._id);
    setMsp_Gallary({
      msp_gallary: row.msp_gallary,
    });
  };

    const onDelete = async (row) => {
    try {
      const confirmResult = await Swal.fire({
        title: "Are you sure?",
        text: "Do you really want to delete this Image?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Delete it!",
        cancelButtonText: "Cancel",
        reverseButtons: true,
        customClass: {
          popup: "small-swal-popup",
          confirmButton: "my-swal-button",
          cancelButton: "my-swal-cancel-button",
        },
      });

      // 🔹 If user cancels, stop execution
      if (!confirmResult.isConfirmed) return;

      const resp = await api.delete(`api/msp/Deletemsp-image/${row._id}`);

      if (resp.status === 200) {
        setTimeout(() => {
          Swal.fire({
            icon: "success",
            title: "Image Deleted",
            text: "Image Deleted Successfully...",
            showConfirmButton: true,
            customClass: {
              popup: "small-swal-popup",
              confirmButton: "my-swal-button",
            },
          }).then(() => {
            window.location.reload();
          });
        }, 0);
      } else {
        console.warn("⚠️ Error:", resp.data.response.data.message);
        setTimeout(() => {
          Swal.fire({
            icon: "error",
            title: "Error Occured",
            text: resp.data.response.data.message,
            showConfirmButton: true,
            customClass: {
              confirmButton: "my-swal-button",
            },
          }).then(() => {
            window.location.reload();
          });
        }, 0);
      }
    } catch (error) {
      console.log(error);
      setTimeout(() => {
        Swal.fire({
          icon: "error",
          title: "Error Occurred",
          text: error.response?.data?.message || "Something went wrong",
          showConfirmButton: true,
          customClass: { confirmButton: "my-swal-button" },
        }).then(() => {
          window.location.reload(); // optional, you can remove this if not needed
        });
      }, 0);
    }
  };

  const columns = [
    {
      field: "sno",
      headerName: "S.No.",
      flex: 0.2,
      renderCell: (params) => params.api.getAllRowIds().indexOf(params.id) + 1,
    },
    {
      field: "msp_gallary",
      headerName: "Photos",
      flex: 1,
      renderCell: (params) => {
        const images = params.value; // array of image URLs

        if (!Array.isArray(images) || images.length === 0) {
          return <span>No Images</span>;
        }

        return (
          <div
            style={{
              display: "flex",
              gap: "10px",
              flexWrap: "wrap",
              alignItems: "center",
            }}
          >
            {images.map((img, index) => (
              <a
                key={index}
                href={img}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={img}
                  alt={`Event ${index + 1}`}
                  style={{
                    width: 40,
                    height: 40,
                    objectFit: "cover",
                    cursor: "pointer",
                    borderRadius: "6px",
                  }}
                />
              </a>
            ))}
          </div>
        );
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 80,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          <IconButton onClick={(e) => handleOpenMenu(e, params.row._id)}>
            <MoreVertIcon />
          </IconButton>

          {menuRowId === params.row._id && (
            <Menu
              anchorEl={menuAnchor}
              open={Boolean(menuAnchor)}
              onClose={handleCloseMenu}
              disableScrollLock
            >
              <MenuItem
                onClick={() => {
                  onEdit(params.row);
                  handleCloseMenu();
                }}
              >
                Edit
              </MenuItem>
              <MenuItem
                onClick={() => {
                   onDelete(params.row);
                  handleCloseMenu();
                }}
              >
                Delete
              </MenuItem>
            </Menu>
          )}
        </>
      ),
    },
  ];

  const rows = All_Msp_Gallary?.map((doc, index) => ({
    id: doc._id || index,
    ...doc,
  }));

  const handleFileChange = async (e) => {
    const files = Array.from(e.target.files);

    // Auto upload when files selected
    await uploadFiles(files);
  };

  // Upload to backend API
  const uploadFiles = async (files) => {
    if (!files.length) return;
    setloading(true);

    const formData = new FormData();
    files.forEach((file) => formData.append("files", file));

    try {
      const res = await api.post("api/upload/upload-files", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setMsp_Gallary({
        ...Msp_Gallary,
        msp_gallary: res.data.urls,
      });
    } catch (error) {
      console.error("Upload failed:", error);
      alert("Upload failed!");
    } finally {
      setloading(false);
    }
  };

  const add_msp_galarry = async () => {
  try {
    setloading(true);

    const payload = {
      ...Msp_Gallary,
    };

    // If editing, attach id
    if (lookup_id) {
      payload.id = lookup_id;
    }

    const resp = await api.post(
      "api/msp/Savemsp-gallary",
      payload
    );

    if (resp.status === 200) {
      Swal.fire({
        icon: "success",
        title: lookup_id
          ? "Msp Gallary Updated"
          : "Msp Gallary Added",
        text: lookup_id
          ? "Msp Gallary Updated Successfully..."
          : "Msp Gallary Uploaded Successfully...",
        showConfirmButton: true,
        customClass: {
          popup: "small-swal-popup",
          confirmButton: "my-swal-button",
        },
      }).then(() => {
        window.location.reload();
      });
    }

  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Error Occurred",
      text: error.response?.data?.message || "Something went wrong",
      showConfirmButton: true,
      customClass: { confirmButton: "my-swal-button" },
    });
  } finally {
    setloading(false);
  }
};


  return (
    <div>
      <Adminheader />

      <div className="layout">
        <Adminsidebar />
        <div className="content-wrapper">
          <div className="main-content">
            <div className="profile-header">
              <h3>Upload MSP Gallary</h3>
              <p>
                Add or update the msp gallary to keep records accurate and
                complete.
              </p>
            </div>

            {/* Form */}
            <Paper elevation={3} sx={{ p: 2, borderRadius: 2 }}>
              <div className="form-grid">
                <FormControl fullWidth size="small">
                  <label className="form-label">Upload MSP Gallary </label>
                  <input
                  multiple
                    type="file"
                    name="msp_gallary"
                    onChange={handleFileChange}
                  ></input>
                </FormControl>
              </div>

              {/* ✅ Image Preview */}
{Msp_Gallary.msp_gallary.length > 0 && (
  <div
    style={{
      display: "flex",
      gap: "10px",
      marginTop: "15px",
      flexWrap: "wrap",
    }}
  >
    {Msp_Gallary.msp_gallary.map((img, index) => (
      <img
        key={index}
        src={img}
        alt="preview"
        width="100"
        height="100"
        style={{
          objectFit: "cover",
          borderRadius: "8px",
          border: "1px solid #ddd",
        }}
      />
    ))}
      </div>
)}

              <Button className="submit-button" onClick={add_msp_galarry}>
                Submit
              </Button>
            </Paper>

            {/* Table */}
            <Paper elevation={3} sx={{ p: 2, borderRadius: 2, marginTop: 4 }}>
              <DataGrid
                className="custom-data-grid"
                rows={rows}
                columns={columns}
                rowCount={rowCount}
                paginationMode="server"
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                pageSizeOptions={[10]}
                disableSelectionOnClick
                // sx={{
                //   minWidth: 800, // Set min width larger than container
                // }}
              />
            </Paper>
          </div>
        </div>
      </div>

      {loading && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(255, 255, 255, 0.6)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <UniqueLoader />
        </div>
      )}
    </div>
  );
}

export default MspGallary;
